module.exports = __webpack_public_path__ + "static/media/Team 17 - Spiral.7fee633f.jpg";